import { Controller } from "@hotwired/stimulus"

// Day/night switch. The saved choice lives in localStorage and is applied by
// an inline script in the layout head before first paint; this controller
// only flips it and keeps the button's state in sync.
export default class extends Controller {
  connect() {
    this.sync()
  }

  toggle() {
    const next = this.current === "dark" ? "light" : "dark"
    document.documentElement.setAttribute("data-theme", next)
    try {
      localStorage.setItem("theme", next)
    } catch (e) {
      // private mode: the choice just won't persist
    }
    this.sync()
  }

  get current() {
    return document.documentElement.getAttribute("data-theme") === "dark" ? "dark" : "light"
  }

  sync() {
    this.element.setAttribute("aria-pressed", String(this.current === "dark"))
  }
}
